import Modal from 'react-overlays/Modal'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { callAPI } from '../hooks/api'
import CustomDropdown from './CustomDropdown'
import useAbility from '@/hooks/use-ability'
import UpgradeLayout from './upgrade-layout'
export default function ApnSearchModal({
  setIsSearchOn,
  isSearchOn,
  onCountyDropdownChange,
  selectedCounty,
  setSelectedCounty,
  setSelectedApn,
  selectedApn,
  queryApn,
  setLoading,
}) {
  const { checkAbility } = useAbility()

  const handleClose = () => {
    setIsSearchOn((prevState) => ({
      ...prevState,
      ['apn']: false,
    }))
    setSelectedCounty(null)
  }
  var handleSuccess = () => {
    console.log('success')
  }
  const renderBackdrop = (props) => <div className="backdrop" {...props} />
  const counties = [
    'Alameda',
    'Alpine',
    'Amador',
    'Butte',
    'Calaveras',
    'Colusa',
    'Contra Costa',
    'Del Norte',
    'El Dorado',
    'Fresno',
    'Glenn',
    'Humboldt',
    'Imperial',
    'Inyo',
    'Kern',
    'Kings',
    'Lake',
    'Lassen',
    'Los Angeles',
    'Madera',
    'Marin',
    'Mariposa',
    'Mendocino',
    'Merced',
    'Modoc',
    'Mono',
    'Monterey',
    'Napa',
    'Nevada',
    'Orange',
    'Placer',
    'Plumas',
    'Riverside',
    'Sacramento',
    'San Benito',
    'San Bernardino',
    'San Diego',
    'San Francisco',
    'San Joaquin',
    'San Luis Obispo',
    'San Mateo',
    'Santa Barbara',
    'Santa Clara',
    'Santa Cruz',
    'Shasta',
    'Sierra',
    'Siskiyou',
    'Solano',
    'Sonoma',
    'Stanislaus',
    'Sutter',
    'Tehama',
    'Trinity',
    'Tulare',
    'Tuolumne',
    'Ventura',
    'Yolo',
    'Yuba',
  ]

  const [apn, setApn] = useState('')
  const [apns, setApns] = useState([])

  const [previousValue, setPreviousValue] = useState('')

  const onFieldChange = (e, field) => {
    const newValue = e.target.value
    const diff = Math.abs(newValue.length - previousValue.length)

    setPreviousValue(newValue)

    setSelectedApn(newValue)

    if (newValue.length < 3) {
      setApns([])
      return
    }

    if (apns.includes(newValue)) return

    const fetchAutoCompleteResults = () => {
      setLoading(true)
      callAPI('/apn_autocomplete', {
        county: selectedCounty,
        query_input: newValue,
      })
        .then((res) => {
          setLoading(false)
          if (res.status === 'fail') {
            toast.warn(res.msg)
            return
          }
          setApns(res.result)
        })
        .catch(() => {
          setLoading(false)
        })
    }

    if (diff > 1 || newValue.length === 3) {
      fetchAutoCompleteResults()
    } else {
      if (apns.length === 0) {
        fetchAutoCompleteResults()
      }
    }
  }
  const apnSample = [
    { Alameda: '74-1265-45' },
    { Alpine: '006121019' },
    { Amador: '004154001000' },
    { Butte: '025-090-009' },
    { Calaveras: '066015014000' },
    { Colusa: '016-270-008-000' },
    { 'Contra Costa': '098560028' },
    { 'Del Norte': '105300035000' },
    { 'El Dorado': '088400037' },
    { Fresno: '33816123S' },
    { Humboldt: '020027004' },
    { Imperial: '046-212-003' },
    { Inyo: '013-090-12' },
    { Kern: '18808208' },
    { Kings: '007410035000' },
    { Lake: '01206918' },
    { Lassen: '001-150-007-000' },
    { 'Los Angeles': '2061-002-052' },
    { Madera: '049262002000' },
    { Marin: '199-093-26' },
    { Mariposa: '021-110-018-000' },
    { Mendocino: '03241033' },
    { Merced: '005080004000' },
    { Modoc: '011-340-017-000' },
    { Mono: '033421035000' },
    { Monterey: '243-221-018-000' },
    { Napa: '011540005000' },
    { Nevada: '016520003000' },
    { Placer: '052-220-030-000' },
    { Plumas: '001450013000' },
    { Riverside: '845163021' },
    { Sacramento: '12105600660000' },
    { 'San Benito': '0210900080' },
    { 'San Bernardino': '046239109' },
    { 'San Diego': '3481121411' },
    { 'San Francisco': '1939045' },
    { 'San Joaquin': '24512033' },
    { 'San Luis Obispo': '091-327-040' },
    { 'San Mateo': '048014080' },
    { 'Santa Barbara': '004-008-037' },
    { 'Santa Clara': '36927009' },
    { 'Santa Cruz': '078-031-06' },
    { Shasta: '094380006000' },
    { Sierra: '015-052-001' },
    { Siskiyou: '003-430-220' },
    { Solano: '0115082040' },
    { Sonoma: '001-173-010' },
    { Stanislaus: '018052037000' },
    { Sutter: '13-240-033' },
    { Tehama: '075-250-031-000' },
    { Trinity: '017-130-06-00' },
    { Tulare: '028-110-009' },
    { Tuolumne: '043-680-006-000' },
    { Ventura: '1580132105' },
    { Yolo: '033190015000' },
    { Yuba: '044400005000' },
  ]
  // Function to get APN by county name
  function getApnByCounty(countyName) {
    const result = apnSample.find((item) => Object.keys(item)[0] === countyName)
    return result ? 'Sample : ' + result[countyName] + '' : '' // Return the APN if found, or null if not
  }

  const enableAPNSearch = checkAbility('apn_search')

  return (
    <>
      <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"></div>
      <div>
        <Modal
          className="modal"
          show={isSearchOn['apn']}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            // display: 'flex',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-170px',
            marginLeft: '-125px',
            width: '250px',
            height: '340px',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 200,
          }}
        >
          <div>
            <div className="modal-header">
              <div className="modal-title">APN SEARCH</div>
              <div>
                <span className="close-button" onClick={handleClose}>
                  x
                </span>
              </div>
            </div>
            <div className="modal-desc">
              <div className="relative" style={{ height: 250 }}>
                <UpgradeLayout
                  title={'Upgrate to use APN Search.'}
                  needUpgrade={!enableAPNSearch}
                />
                <strong>County</strong>
                <br />

                <select
                  defaultValue=""
                  className="w-full px-4 py-2 text-base text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                  onChange={(e) => {
                    setSelectedApn('')
                    setApns([])
                    onCountyDropdownChange(e)
                  }}
                >
                  <option value="" disabled>
                    Select a county
                  </option>
                  {counties.map((county) => (
                    <option value={county}>{county}</option>
                  ))}
                </select>
                {/* <Dropdown options={counties} onChange={onCountyDropdownChange} placeholder="Select a county" /> */}
                {selectedCounty && (
                  <>
                    <div className="pt-3 pb-3">
                      <CustomDropdown
                        label={`APN (${selectedCounty})`}
                        data={selectedApn}
                        dataList={apns}
                        onFieldChange={onFieldChange}
                        field="main_crop"
                        startingLength={3}
                        sample={getApnByCounty(selectedCounty)}
                      />
                    </div>
                    <button
                      onClick={async () => {
                        if (!selectedApn)
                          toast.warn(
                            'Please specify APN(s) you would like to query.'
                          )
                        else {
                          var res = await queryApn(
                            selectedCounty,
                            selectedApn,
                            '',
                            '',
                            ''
                          )
                          handleClose()
                        }
                      }}
                      className="px-7 py-3 bg-gray-600 text-white font-medium text-sm uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg w-full text-center transition duration-150 ease-in-out "
                    >
                      Search
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
}
